import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { AUTUMN_GUIDES } from './autumnGuides';
import './Autumn.css';

const AutumnGuidePage = () => {
  const { slug } = useParams();
  const guide = AUTUMN_GUIDES.find((item) => item.slug === slug);

  if (!guide) {
    return <Navigate to="/autumn" replace />;
  }

  return (
    <iframe
      className="autumn-guide-frame"
      title={`${guide.label} care guide`}
      src={`/autumn/${guide.file}`}
    />
  );
};

export default AutumnGuidePage;
